// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".flex[data-v-190c4e65]{display:flex}.cols p[data-v-190c4e65]{margin:0;font-size:14px}.info[data-v-190c4e65]{width:35%}", ""]);
// Exports
module.exports = exports;
